// extracted by mini-css-extract-plugin
module.exports = {"errors__notice":"ErrorNotice_errors__notice_QHvwA"};